import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate"

import user from "./modules/user"
import contracts from "./modules/contracts"
import transactions from "./modules/transactions"
import web3 from "./modules/web3"

Vue.use(Vuex)

const modules = {
  user,
  contracts,
  transactions,
  web3
}

export default new Vuex.Store({
  modules,
  plugins: [
    createPersistedState({
      key: "mtx-txs",
      paths: ["transactions.pending"]
    })
  ]
})
